/**
 * 2026년 한국 주식 시장 표준 수수료 및 거래세 계산
 */

// 증권사 수수료율 (매수/매도 모두 동일)
// 2026년 기준 주요 증권사 평균 수수료율: 약 0.015% ~ 0.05%
// 표준 수수료율로 0.015% 적용 (일반적인 온라인 주문 기준)
export const BROKERAGE_FEE_RATE = 0.00015; // 0.015%

// 거래세율 (매도 시에만 부과)
// 2026년 기준 증권거래세율: 0.20% (2025년 0.15%에서 인상)
export const TRANSACTION_TAX_RATE = 0.002; // 0.20%

/**
 * 매수 시 총 비용 계산 (주가 × 수량 + 수수료)
 * @param price - 주가
 * @param quantity - 수량
 * @returns 총 비용 (주가 × 수량 + 수수료)
 */
export const calculateBuyCost = (price: number, quantity: number): number => {
  const baseAmount = price * quantity;
  const brokerageFee = Math.floor(baseAmount * BROKERAGE_FEE_RATE);
  return baseAmount + brokerageFee;
};

/**
 * 매도 시 실제 수익 계산 (주가 × 수량 - 수수료 - 거래세)
 * @param price - 주가
 * @param quantity - 수량
 * @returns 실제 수익 (주가 × 수량 - 수수료 - 거래세)
 */
export const calculateSellRevenue = (
  price: number,
  quantity: number
): number => {
  const baseAmount = price * quantity;
  const brokerageFee = Math.floor(baseAmount * BROKERAGE_FEE_RATE);
  const transactionTax = Math.floor(baseAmount * TRANSACTION_TAX_RATE);
  return baseAmount - brokerageFee - transactionTax;
};

/**
 * 수수료만 계산 (매수/매도 공통)
 * @param price - 주가
 * @param quantity - 수량
 * @returns 수수료
 */
export const calculateBrokerageFee = (
  price: number,
  quantity: number
): number => {
  const baseAmount = price * quantity;
  return Math.floor(baseAmount * BROKERAGE_FEE_RATE);
};

/**
 * 거래세 계산 (매도 시에만)
 * @param price - 주가
 * @param quantity - 수량
 * @returns 거래세
 */
export const calculateTransactionTax = (
  price: number,
  quantity: number
): number => {
  const baseAmount = price * quantity;
  return Math.floor(baseAmount * TRANSACTION_TAX_RATE);
};

/**
 * 주식 평가액 계산 (현재가 × 수량 - 매도 수수료 - 거래세)
 * 매도 시 실제로 받을 수 있는 금액을 기준으로 평가액 계산
 * @param currentPrice - 현재 주가
 * @param quantity - 보유 수량
 * @returns 평가액 (매도 비용 차감 후)
 */
export const calculateStockValue = (
  currentPrice: number,
  quantity: number
): number => {
  if (quantity <= 0) return 0;
  const baseAmount = currentPrice * quantity;
  const brokerageFee = Math.floor(baseAmount * BROKERAGE_FEE_RATE);
  const transactionTax = Math.floor(baseAmount * TRANSACTION_TAX_RATE);
  return baseAmount - brokerageFee - transactionTax;
};

